import isArray from 'lodash/isArray';
import isUndefined from 'lodash/isUndefined';
import slice from 'lodash/slice';

export default function getNamedChildren(element=document, query="") {
    let children = slice(element.querySelectorAll(`[name${query}]`));
    let map = {};
    let name;
    children.forEach(child => {
        name = child.getAttribute('name');
        if(isArray(map[name])) {
            map[name].push(child);
        } else if(isUndefined(map[name])) {
            map[name] = child;
        } else {
            map[name] = [map[name], child];
        }
    });
    return map;
};



/** WEBPACK FOOTER **
 ** ./utils/get-named-children.js
 **/